import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumb as AntdBreadcrumb, Collapse as AntdCollapse, Menu as AntdMenu, Pagination as AntdPagination, Steps as AntdSteps, } from 'antd';
import { Icon } from '../icons/icon.js';
import { persianItemRender, persianShowTotal, withRegistrySizeChangerIcon } from './table.js';
/**
 * The sider menu.
 *
 * AntD already mirrors the inline submenu indent and the popup side under
 * `direction="rtl"`; what it draws with `@ant-design/icons` is the submenu
 * arrow and the collapsed-mode overflow indicator. Both come from the registry
 * here, and the submenu arrow is directional so it points at the side the
 * flyout will actually appear on.
 */
export function Menu({ expandIcon, overflowedIndicator, ...rest }) {
    return (_jsx(AntdMenu, { ...rest, expandIcon: expandIcon === undefined ? _jsx(Icon, { name: "chevron-forward", size: 16 }) : expandIcon, overflowedIndicator: overflowedIndicator === undefined ? _jsx(Icon, { name: "more", size: 16 }) : overflowedIndicator }));
}
Menu.Item = AntdMenu.Item;
Menu.SubMenu = AntdMenu.SubMenu;
Menu.ItemGroup = AntdMenu.ItemGroup;
Menu.Divider = AntdMenu.Divider;
/**
 * The trail.
 *
 * AntD's stock separator is the literal character `/`, which does not mirror
 * and reads as a slash between two Persian words. A chevron is what a trail
 * means, and `chevron-forward` is the one that points from the ancestor toward
 * the current page in either direction.
 */
export function Breadcrumb({ separator, ...rest }) {
    return (_jsx(AntdBreadcrumb, { ...rest, separator: separator === undefined ? (_jsx(Icon, { name: "chevron-forward", size: 16, className: "bk-breadcrumb-sep" })) : (separator) }));
}
/**
 * A wizard's progress.
 *
 * AntD positions the tail and the arrow head with logical properties, so a
 * horizontal `Steps` in RTL runs right-to-left and `type="navigation"` points
 * with it. What it does not supply is the finished/failed glyph — those are
 * `@ant-design/icons` by default and are replaced here so a completed step
 * carries the same tick the rest of the panel uses.
 */
export function Steps({ items, ...rest }) {
    const decorated = items?.map((item) => item.icon === undefined && item.status === 'finish'
        ? { ...item, icon: _jsx(Icon, { name: "check", size: 20, active: true }) }
        : item.icon === undefined && item.status === 'error'
            ? { ...item, icon: _jsx(Icon, { name: "danger", size: 20, active: true }) }
            : item);
    return _jsx(AntdSteps, { ...rest, items: decorated });
}
/** Accordion. The disclosure chevron rotates from the reading-start side. */
export function Collapse({ expandIcon, ...rest }) {
    return (_jsx(AntdCollapse, { ...rest, expandIcon: expandIcon ??
            (({ isActive }) => (_jsx(Icon, { name: isActive ? 'chevron-down' : 'chevron-forward', size: 16, active: isActive }))) }));
}
Collapse.Panel = AntdCollapse.Panel;
/**
 * Standalone pagination — for a list that is not a `<Table>`.
 *
 * Same treatment as the table's footer: Persian page numbers, and prev/next
 * arrows that resolve against the document instead of AntD's fixed `‹` / `›`.
 */
export function Pagination({ itemRender, showTotal, showSizeChanger, ...rest }) {
    return (_jsx(AntdPagination, { ...rest, itemRender: itemRender ?? paginationItemRender, showTotal: showTotal ?? persianShowTotal, showSizeChanger: withRegistrySizeChangerIcon(showSizeChanger) }));
}
function paginationItemRender(page, type, element) {
    return persianItemRender(page, type, element);
}
//# sourceMappingURL=navigation.js.map